import React from 'react';

// placement: 'top-left'（既定）／'top-right'。キャンバスの左上に別の目印が来る画面で右上へ逃がす
export default function AxisLegend({ isVisible = true, placement = 'top-left' }) {
  if (!isVisible) return null;

  const side = placement === 'top-right' ? ' axes-legend--right' : '';
  return (
    <div className={`axes-legend axes-legend--tiny${side}`} aria-hidden="true">
      <div className="axes-legend__item">
        <span className="axes-legend__swatch axes-legend__swatch--x" />
        <span className="axes-legend__label">X</span>
      </div>
      <div className="axes-legend__item">
        <span className="axes-legend__swatch axes-legend__swatch--y" />
        <span className="axes-legend__label">Y</span>
      </div>
      <div className="axes-legend__item">
        <span className="axes-legend__swatch axes-legend__swatch--z" />
        <span className="axes-legend__label">Z</span>
      </div>
    </div>
  );
}
